import {
  ArchiveBoxIcon,
  ClipboardDocumentListIcon,
  CubeIcon,
  TruckIcon,
  UserIcon,
} from "@heroicons/react/24/outline";

import classNames from "../../../utils/classNames";
import { SearchPaletteItemType } from "./SearchPaletteTypes";

interface SearchPaletteTypePillProps {
  type: SearchPaletteItemType;
  fixedWidth?: boolean;
  className?: string;
  nested?: boolean;
}

export default function SearchPaletteTypePill({
  type,
  fixedWidth = false,
  className = "",
  nested = false,
}: SearchPaletteTypePillProps) {
  const Icon = getTypeIcon(type);
  const classes = getTypePillClasses(type, nested);

  return (
    <span
      className={classNames(
        "inline-flex shrink-0 items-center justify-center rounded-full font-medium",
        nested
          ? "gap-1 px-2 py-0.5 text-[11px]"
          : "gap-1.5 px-2 py-1 text-xs ring-1 ring-inset",
        fixedWidth ? "w-24" : "",
        classes,
        className
      )}
    >
      <Icon className={nested ? "h-3.5 w-3.5" : "h-3.5 w-3.5"} />
      {type}
    </span>
  );
}

export function getTypeIcon(type: SearchPaletteItemType) {
  switch (type) {
    case "Lead":
      return CubeIcon;
    case "Vehicle":
      return TruckIcon;
    case "Order":
      return ClipboardDocumentListIcon;
    case "Stock":
      return ArchiveBoxIcon;
    case "User":
      return UserIcon;
    default:
      return CubeIcon;
  }
}

export function getTypePillClasses(
  type: SearchPaletteItemType,
  nested = false
): string {
  switch (type) {
    case "Lead":
      return nested
        ? "bg-emerald-50 text-emerald-700"
        : "bg-emerald-50 text-emerald-700 ring-emerald-200";
    case "Vehicle":
      return nested
        ? "bg-blue-50 text-blue-700"
        : "bg-blue-50 text-blue-700 ring-blue-200";
    case "Order":
      return nested
        ? "bg-purple-50 text-purple-700"
        : "bg-purple-50 text-purple-700 ring-purple-200";
    case "Stock":
      return nested
        ? "bg-amber-50 text-amber-700"
        : "bg-amber-50 text-amber-700 ring-amber-200";
    case "User":
      return nested
        ? "bg-emerald-50 text-emerald-700"
        : "bg-emerald-50 text-emerald-700 ring-emerald-200";
    default:
      return nested
        ? "bg-gray-100 text-gray-700"
        : "bg-gray-100 text-gray-700 ring-gray-200";
  }
}